// Styles for MissingStayRequestConfirmation go here.
import styled from 'styled-components';
import { toRem, baseVariables } from '@marriott/mi-ui-library';

export const StyledReportMissingStayRequestConfirmation = styled.div`
  .request-confirmation {
    border-radius: ${toRem(10)};

    &__line {
      color: ${baseVariables.color['neutral30']};
    }
  }
`;
